import type { Action } from 'redux';

export const CLEAR_PAM_NOTIFICATION_CONFIG = 'CLEAR_PAM_NOTIFICATION_CONFIG' as const;

export const clearPamNotificationConfig = () => ({ type: CLEAR_PAM_NOTIFICATION_CONFIG });

export type ClearPamNotificationConfigAction = Action<typeof CLEAR_PAM_NOTIFICATION_CONFIG>;
